interface Project {
  title: string;
  org: string;
  description: string;
  tags: string[];
  link: string;
  linkLabel: string;
}

const publicSectorProjects: Project[] = [
  {
    title: 'SENA Digital Transformation',
    org: 'Leicestershire County Council - Digital Services Team',
    description:
      "Led the digitisation of a complex statutory Special Educational Needs paper process into a fully digital Granicus multi-stage form. Designed conditional routing logic, integrated three external APIs, applied WCAG accessibility standards, used data insight to refine user journeys, and worked collaboratively with Children's Services stakeholders throughout. Achieved a 50% SLA improvement, from 40 to 20 weeks.",
    tags: ['Granicus GovService', 'GOV.UK Notify', 'Azure AI', 'GOV.UK Chat', 'Power BI', 'WCAG 2.1 AA', 'GDS Standards'],
    link: 'https://www.leicestershire.gov.uk/',
    linkLabel: 'leicestershire.gov.uk'
  },
  {
    title: 'Council Website and Forms Portfolio',
    org: 'Leicestershire County Council',
    description:
      'Built and maintained Drupal-based council websites and Granicus digital forms across multiple service areas, conducting WCAG accessibility audits, refining content design for plain-English clarity, and tracking channel-shift analytics to measure resident take-up of digital services over paper and phone channels.',
    tags: ['Granicus GovService', 'Drupal CMS', 'WCAG 2.1 AA', 'GOV.UK Notify', 'GDS Standards', 'Channel Shift Analytics'],
    link: 'https://www.leicestershire.gov.uk/',
    linkLabel: 'leicestershire.gov.uk'
  },
  {
    title: 'Internal & External AI Chatbot',
    org: 'Leicestershire County Council',
    description:
      'Built both a public-facing chatbot for residents and an internal chatbot for council staff through a custom Drupal module, using Azure AI Foundry for the underlying model, Microsoft Direct Line for the conversational channel integration, and Microsoft Cosmos DB for session and conversation storage. Applied GDS-aligned AI governance and GDPR-safe data handling throughout.',
    tags: ['Drupal (custom module)', 'Azure AI Foundry', 'Microsoft Direct Line', 'Microsoft Cosmos DB', 'GDPR', 'AI Governance'],
    link: 'https://www.leicestershire.gov.uk/',
    linkLabel: 'leicestershire.gov.uk'
  }
];

const personalProjects: Project[] = [
  {
    title: 'TriFinder - Job Finding Platform',
    org: 'Sole developer',
    description:
      'A job finding platform that connects job seekers with employers, streamlining the recruitment process and surfacing better-matched opportunities for both parties.',
    tags: ['TypeScript', 'React', 'Node.js', 'Azure', 'PostgreSQL', 'Docker'],
    link: 'https://trifinder.trifusion.co.uk',
    linkLabel: 'View project'
  },
  {
    title: 'Trifusion AI - Corporate AI Platform',
    org: 'Sole developer',
    description:
      'A corporate AI platform that uses machine learning to provide actionable insights, optimise business processes and support informed decision-making.',
    tags: ['React', 'TypeScript', 'Node.js', 'PostgreSQL', 'Docker', 'Claude API'],
    link: 'https://ai.trifusion.co.uk',
    linkLabel: 'View project'
  },
  {
    title: 'TriPayments - ePOS System',
    org: 'Sole developer',
    description:
      'A secure, user-friendly ePOS system that streamlines point-of-sale operations for restaurants, cafes and other service establishments.',
    tags: ['PHP', 'Node.js', 'PostgreSQL', 'Stripe', 'JavaScript'],
    link: 'https://payments.trifusion.co.uk',
    linkLabel: 'View project'
  }
];

function ProjectCard({ project }: { project: Project }) {
  return (
    <div className="govuk-grid-column-one-third">
      <div className="govuk-!-padding-4" style={{ background: '#ffffff', border: '1px solid #b1b4b6', height: '100%' }}>
        <h4 className="govuk-heading-s govuk-!-margin-bottom-1">{project.title}</h4>
        <p className="govuk-body-s govuk-!-margin-bottom-3" style={{ color: '#505a5f' }}>{project.org}</p>
        <p className="govuk-body govuk-!-margin-bottom-3">{project.description}</p>
        <p className="govuk-!-margin-bottom-3">
          {project.tags.map((tag) => (
            <strong key={tag} className="govuk-tag govuk-tag--grey govuk-!-margin-right-1 govuk-!-margin-bottom-1">
              {tag}
            </strong>
          ))}
        </p>
        <p className="govuk-body govuk-!-margin-bottom-0">
          <a className="govuk-link" href={project.link} target="_blank" rel="noopener noreferrer">
            {project.linkLabel}
          </a>
        </p>
      </div>
    </div>
  );
}

export default function Projects() {
  return (
    <div id="projects" className="app-hero">
      <div className="govuk-width-container govuk-!-padding-top-8 govuk-!-padding-bottom-8">
        <h2 className="govuk-heading-l">Projects</h2>

        <h3 className="govuk-heading-m govuk-!-margin-top-6">Public sector delivery</h3>
        <p className="govuk-body">Selected work delivered as part of my placement at Leicestershire County Council.</p>
        <div className="govuk-grid-row">
          {publicSectorProjects.map((project) => (
            <ProjectCard key={project.title} project={project} />
          ))}
        </div>

        <h3 className="govuk-heading-m govuk-!-margin-top-8">Personal projects</h3>
        <p className="govuk-body">Alongside client and council work, I design and build my own products as sole developer.</p>
        <div className="govuk-grid-row">
          {personalProjects.map((project) => (
            <ProjectCard key={project.title} project={project} />
          ))}
        </div>
      </div>
    </div>
  );
}
